import { createAsyncThunk } from '@reduxjs/toolkit';
import publicApi from 'api/publicApi';

// Thunk verify token, trả về dữ liệu hoặc lỗi
export const verifyToken = createAsyncThunk(
  'public/verifyToken',
  async (token: string, { rejectWithValue }) => {
    try {
      const response = await publicApi.verifyToken(token);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Token không hợp lệ');
    }
  }
);

// Thunk submit dữ liệu employee public
export const submitEmployeeData = createAsyncThunk(
  'public/submitEmployeeData',
  async ({ token, data }: { token: string; data: any }, { rejectWithValue }) => {
    try {
      const response = await publicApi.submitEmployeeData({ token, data });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Lỗi gửi dữ liệu');
    }
  }
);
